<!--
 * @Description: 附件回显组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-02-25 14:00:17
 * @LastEditTime: 2019-04-30 14:42:11
 -->
<template>
    <a :href="file.fileurl" target='_blank'>
        <i :class="['iconfont', 'icon', icon]"></i>
        <span>{{file.filename}}</span>
    </a>
</template>

<script>
    import {
        workBaseURL
    } from '../config/index.js'
    export default {
        props: {
            file: { //传递过来的文件数据
                type: Object
            }
        },
        computed: {
            icon() { //文件类型icon默认是word文件
                let suffix = this.file.filename.slice(
                    this.file.filename.lastIndexOf(".") + 1
                );
                if (suffix == "doc" || suffix == "docx") {
                    return "icon-doc";
                } else if (suffix == "xls" || suffix == "xlsx") {
                    return "icon-xls";
                } else if (suffix == "pdf") {
                    return "icon-pdf";
                } else if (suffix == "zip") {
                    return "icon-zip";
                } else if (suffix == "txt") {
                    return "icon-txt";
                } else if (suffix == "ppt" || suffix == "pptx") {
                    return "icon-ppt";
                } else {
                    return "icon-doc";
                }
            }
        },
        data() {
            return {
                workBaseURL
            };
        },
        components: {},
        created() {
            //将url变成可下载的url路径
            this.url = "";
            // "?fileids=" +
            // this.file.fileid +
            // "&pathUrl=" +
            // this.file.fileurl.replace(/\\/g, "/");
        }
    };
</script>

<style scoped lang="less">
    .file_item {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-right: 6px;
        position: relative;
        cursor: pointer;
        margin-right: 20px;

        >.icon {
            margin-right: 6px;
            color: #3ca4fb;
            font-size: 20px;
        }

        >.icon-shanchu1 {
            font-size: 16px;
            position: absolute;
            right: -8px;
            top: -8px;
            color: #ff2a00;
        }
    }
</style>